/* ==========================================================================
   Technichem Motion — shared animation primitives
   Three behaviors wired by data attributes:
     [data-tc-reveal]  — fade/slide in when 15% visible
     [data-tc-count]   — animate number from 0 to target at 40% visible
     [data-tc-slider]  — draggable before/after handle
   Respects prefers-reduced-motion. Fires immediately in Shopify theme editor.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inThemeEditor = !!(window.Shopify && window.Shopify.designMode);

  /* -------- Reveal -------- */
  function wireReveal() {
    var targets = document.querySelectorAll('[data-tc-reveal]');
    if (!targets.length) return;
    if (reduceMotion || inThemeEditor || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* -------- Counter -------- */
  function parseTarget(raw) {
    var match = String(raw || '').match(/^(\d[\d,]*)(.*)$/);
    if (!match) return null;
    return { num: parseInt(match[1].replace(/,/g, ''), 10), suffix: match[2] || '' };
  }

  function animateNumber(el, target, duration) {
    var start = performance.now();
    function tick(now) {
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = Math.round(target.num * eased).toLocaleString() + target.suffix;
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function wireCounters() {
    var targets = document.querySelectorAll('[data-tc-count]');
    if (!targets.length) return;
    targets.forEach(function (el) {
      var parsed = parseTarget(el.getAttribute('data-tc-count') || el.textContent);
      if (!parsed) return;
      if (reduceMotion || inThemeEditor || !('IntersectionObserver' in window)) {
        el.textContent = parsed.num.toLocaleString() + parsed.suffix;
        return;
      }
      el.textContent = '0' + parsed.suffix;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateNumber(el, parsed, 1200);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  /* -------- Before/After Slider -------- */
  function wireSlider(root) {
    var range = root.querySelector('input[type="range"]');
    var after = root.querySelector('.tc-ba-slider__after');
    var handle = root.querySelector('.tc-ba-slider__handle');
    if (!range || !after || !handle) return;
    if (root.dataset.tcSliderReady) return;
    root.dataset.tcSliderReady = '1';

    function apply(v) {
      var pct = Math.max(0, Math.min(100, Number(v)));
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
      range.setAttribute('aria-valuenow', Math.round(pct));
    }
    apply(range.value);
    range.addEventListener('input', function () { apply(range.value); });

    function pctFromClientX(clientX) {
      var rect = root.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    handle.addEventListener('pointerdown', function (e) {
      handle.setPointerCapture(e.pointerId);
      range.value = Math.max(0, Math.min(100, pctFromClientX(e.clientX)));
      apply(range.value);
      e.preventDefault();
    });
    handle.addEventListener('pointermove', function (e) {
      if (!handle.hasPointerCapture(e.pointerId)) return;
      range.value = Math.max(0, Math.min(100, pctFromClientX(e.clientX)));
      apply(range.value);
    });
    handle.addEventListener('pointerup', function (e) {
      if (handle.hasPointerCapture(e.pointerId)) handle.releasePointerCapture(e.pointerId);
    });
  }

  function wireSliders() {
    document.querySelectorAll('[data-tc-slider]').forEach(wireSlider);
  }

  function init() {
    wireReveal();
    wireCounters();
    wireSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor: re-init when sections are reloaded
  document.addEventListener('shopify:section:load', init);
})();
